import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const paymentType = {
  path: '/stocksSryaWarehouses',
  component: Layout,
  name: 'stocksSryaWarehouses',
  redirect: '/stocksSryaWarehouses/index',
  children: [{
    path: '/stocksSryaWarehouses/index',
    component: () => import('@/views/stocksSryaWarehouses/index'),
    name: 'stocksSryaWarehouses.index',
    meta: {
      title: i18n.t(`message.warehouses`)
    }
  }, ]
}

export default paymentType